export const quizQuestions = [
  // Acidity Breaker Screen
  {
    id: 1,
    type: 'breaker',
    category: 'acidity',
    title: 'ACIDITY',
    instructions: 'Next you are going to be asked to select your preference for acidity across several different themes.\n\nPlease use your best judgment to select the choice that sounds the most appealing, even if one of the themes doesn\'t appeal to you or you are not familiar with it.'
  },
  
  // Acidity Questions
  {
    id: 2,
    category: 'acidity',
    question: 'How do you like your acidity?',
    subtitle: 'Salad Dressings',
    options: [
      { text: 'Lemon Vinaigrette', value: 'high' },
      { text: 'Balsamic Vinaigrette', value: 'medium' },
      { text: 'Ranch Dressing', value: 'low' }
    ]
  },
  {
    id: 3,
    category: 'acidity',
    question: 'How do you like your acidity?',
    subtitle: 'Apples',
    options: [
      { text: 'Green Apples', value: 'high' },
      { text: 'Yellow Apples', value: 'medium' },
      { text: 'Red Apples', value: 'low' }
    ]
  },
  {
    id: 4,
    category: 'acidity',
    question: 'How do you like your acidity?',
    subtitle: 'Berries',
    options: [
      { text: 'Cranberries', value: 'high' },
      { text: 'Strawberries', value: 'medium' },
      { text: 'Blueberries', value: 'low' }
    ]
  },
  {
    id: 5,
    category: 'acidity',
    question: 'How do you like your acidity?',
    subtitle: 'Pasta Sauce',
    options: [
      { text: 'Lemon Butter', value: 'high' },
      { text: 'Marinara', value: 'medium' },
      { text: 'Cream', value: 'low' }
    ]
  },
  {
    id: 6,
    category: 'acidity',
    question: 'How do you like your acidity?',
    subtitle: 'Chips',
    options: [
      { text: 'Salt and Vinegar', value: 'high' },
      { text: 'BBQ', value: 'medium' },
      { text: 'Plain', value: 'low' }
    ]
  },
  {
    id: 7,
    category: 'acidity',
    question: 'How do you like your acidity?',
    subtitle: 'Coffee',
    options: [
      { text: 'Light Roast', value: 'high' },
      { text: 'Medium Roast', value: 'medium' },
      { text: 'Dark Roast', value: 'low' }
    ]
  },

  // Sweetness Breaker Screen
  {
    id: 8,
    type: 'breaker',
    category: 'sweetness',
    title: 'SWEETNESS',
    instructions: 'Next you are going to be asked to select your preference for sweetness across several different themes.\n\nPlease use your best judgment to select the choice that sounds the most appealing, even if one of the themes doesn\'t appeal to you or you are not familiar with it.'
  },

  // Sweetness Questions
  {
    id: 9,
    category: 'sweetness',
    question: 'How do you like your sweetness?',
    subtitle: 'Fruit',
    options: [
      { text: 'Mango', value: 'high' },
      { text: 'Strawberry', value: 'medium' },
      { text: 'Raspberry', value: 'low' }
    ]
  },
  {
    id: 10,
    category: 'sweetness',
    question: 'How do you like your sweetness?',
    subtitle: 'Dessert',
    options: [
      { text: 'Fruit and Cheese', value: 'low' },
      { text: 'Cherry Cobbler', value: 'medium' },
      { text: 'Brownie with Cake Batter Ice Cream', value: 'high' }
    ]
  },
  {
    id: 11,
    category: 'sweetness',
    question: 'How do you like your sweetness?',
    subtitle: 'Banana',
    options: [
      { text: 'Green', value: 'low' },
      { text: 'Yellow', value: 'medium' },
      { text: 'Brown', value: 'high' }
    ]
  },
  {
    id: 12,
    category: 'sweetness',
    question: 'How do you like your sweetness?',
    subtitle: 'Breakfast',
    options: [
      { text: 'Plain Oatmeal', value: 'low' },
      { text: 'Yogurt with Fruit', value: 'medium' },
      { text: 'Donuts', value: 'high' }
    ]
  },
  {
    id: 13,
    category: 'sweetness',
    question: 'How do you like your sweetness?',
    subtitle: 'Summer Drinks',
    options: [
      { text: 'Unsweetened Iced Tea', value: 'low' },
      { text: 'Sweet Tea', value: 'medium' },
      { text: 'Soda', value: 'high' }
    ]
  },
  {
    id: 14,
    category: 'sweetness',
    question: 'How do you like your sweetness?',
    subtitle: 'Vegetables in Your Salad',
    options: [
      { text: 'Cucumber', value: 'low' },
      { text: 'Sweet Corn', value: 'medium' },
      { text: 'Beets', value: 'high' }
    ]
  },

  // Body Breaker Screen
  {
    id: 15,
    type: 'breaker',
    category: 'body',
    title: 'BODY',
    instructions: 'Next you are going to be asked to select your preference for body across several different themes.\n\nPlease use your best judgment to select the choice that sounds the most appealing, even if one of the themes doesn\'t appeal to you or you are not familiar with it.'
  },

  // Body Questions
  {
    id: 16,
    category: 'body',
    question: 'How do you like your body?',
    subtitle: 'Beer',
    options: [
      { text: 'Light Beer', value: 'light' },
      { text: 'Sour Beer', value: 'medium' },
      { text: 'IPA', value: 'full' }
    ]
  },
  {
    id: 17,
    category: 'body',
    question: 'How do you like your body?',
    subtitle: 'Tea',
    options: [
      { text: 'White', value: 'light' },
      { text: 'Matcha', value: 'medium' },
      { text: 'Black', value: 'full' }
    ]
  },
  {
    id: 18,
    category: 'body',
    question: 'How do you like your body?',
    subtitle: 'Chocolate',
    options: [
      { text: 'White Chocolate', value: 'light' },
      { text: 'Milk Chocolate', value: 'medium' },
      { text: 'Dark Chocolate', value: 'full' }
    ]
  },
  {
    id: 19,
    category: 'body',
    question: 'How do you like your body?',
    subtitle: 'Cheese',
    options: [
      { text: 'Mozzarella', value: 'light' },
      { text: 'Cheddar', value: 'medium' },
      { text: 'Blue', value: 'full' }
    ]
  },
  {
    id: 20,
    category: 'body',
    question: 'How do you like your body?',
    subtitle: 'Protein',
    options: [
      { text: 'Tofu', value: 'light' },
      { text: 'Chicken', value: 'medium' },
      { text: 'Steak', value: 'full' }
    ]
  },
  {
    id: 21,
    category: 'body',
    question: 'How do you like your body?',
    subtitle: 'Music',
    options: [
      { text: 'Classical', value: 'light' },
      { text: 'R&B Soul', value: 'medium' },
      { text: 'Heavy Metal', value: 'full' }
    ]
  }
];

export const calculatePreference = (answers, category) => {
  const categoryAnswers = answers.filter(answer => answer.category === category);
  const values = categoryAnswers.map(answer => answer.value);
  
  console.log(`Calculating ${category} preference from:`, values);
  
  // Count occurrences
  const counts = values.reduce((acc, val) => {
    acc[val] = (acc[val] || 0) + 1;
    return acc;
  }, {});
  
  console.log(`Counts for ${category}:`, counts);
  
  // Determine preference based on most common answer
  const maxCount = Math.max(...Object.values(counts));
  const preference = Object.keys(counts).find(key => counts[key] === maxCount);
  
  console.log(`Final ${category} preference:`, preference);
  
  return preference;
};
